import type { KindType } from '@/app/cc/_types/types';

export interface ConsultationFormData {
  name: string;
  phone: string;
  inflow: KindType;
  counselingTime: 'AM' | 'PM' | 'ALL';
  contractFlag: boolean;
  privacyUseFlag: boolean;
  privacyProvideFlag: boolean;
}

export function createInitialConsultationForm(kind: KindType): ConsultationFormData {
  return {
    name: '',
    phone: '',
    inflow: kind,
    counselingTime: 'ALL',
    contractFlag: true,
    privacyUseFlag: false,
    privacyProvideFlag: false,
  };
}
